import { render } from "./company-register.vue?vue&type=template&id=1f3a6861&scoped=true"
import script from "./company-register.vue?vue&type=script&lang=js"
export * from "./company-register.vue?vue&type=script&lang=js"

import "./company-register.vue?vue&type=style&index=0&id=1f3a6861&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3a6861"]])

export default __exports__